export default __webpack_public_path__ + "static/media/prev.0a138885.svg";